<template>
  <div class="dynamic-component" v-if="config.visible !== false">
    <component 
      :is="componentName" 
      :config="config.data || {}"
      @action="handleAction"
    />
  </div>
</template>

<script>
// 导入所有可动态渲染的组件
import BannerSection from './BannerSection.vue'
import MarqueeNotice from './MarqueeNotice.vue'
import CountdownTimer from './CountdownTimer.vue'
import FormSection from './FormSection.vue'
import BenefitsSection from './BenefitsSection.vue'
import OrderNotice from './OrderNotice.vue'
import ProductInfo from './ProductInfo.vue'
import PriceSelector from './PriceSelector.vue'

// 组件映射表
const componentMap = {
  BannerSection,
  MarqueeNotice,
  CountdownTimer,
  FormSection,
  BenefitsSection,
  OrderNotice,
  ProductInfo,
  PriceSelector
}

export default {
  name: 'DynamicComponent',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    componentName() {
      return componentMap[this.config.type] || null
    }
  },
  methods: {
    handleAction(action) {
      this.$emit('action', { 
        componentId: this.config.id, 
        componentType: this.config.type,
        ...action 
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dynamic-component {
  width: 100%;
}
</style>
